import app from "../../configs/FirebaseConfig";
import { setLocalStoreString } from "../../utils/Helper";

const currentTime = new Date();

const RefreshTimestamp = new Date(localStorage.getItem("RefreshTimestamp"));

const diffMiliseconds = currentTime - RefreshTimestamp;

var diffMins = Math.round(diffMiliseconds / 60000);

async function refreshTokenWorker() {
    const RefreshToken = localStorage.getItem("RefreshToken")
    const BearerToken = localStorage.getItem("BearerToken")
    if (diffMins > 60 || !BearerToken) {
        return fetch(
            `https://securetoken.googleapis.com/v1/token?key=${app._options.apiKey}`,
            {
                method: "POST",
                body: JSON.stringify({
                    refresh_token: RefreshToken,
                    grant_type: "refresh_token",
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                },
            }
        ).then(data => data.json()).then(responseData => {
            if (responseData.access_token) {
                setLocalStoreString("BearerToken", responseData.access_token);
            }
            setLocalStoreString("RefreshTimestamp", currentTime.toString());
            return responseData.access_token ? responseData.access_token : ""

        })
    }
}
export default refreshTokenWorker;